/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathMin = createReactComponent("math-min", "IconMathMin", [
  ["path", { d: "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z", key: "svg-0" }],
  ["path", { d: "M3 4c0 8.75 4 14 7 14.5", key: "svg-1" }],
  ["path", { d: "M14 18.5c3 -.5 7 -5.75 7 -14.5", key: "svg-2" }]
]);

export { IconMathMin as default };
//# sourceMappingURL=IconMathMin.js.map
